export class UserProfileImageRequest {
  image: string;
  imageName: string;

  constructor(image?: string, imageName?: string) {
    this.image = image?.split(',').pop() ?? '';
    this.imageName = imageName ?? '';
  }
}
